import './AdsPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";

import { getAds, putAd, setAd } from "./store/actions";

import A from 'components/A';
import AdEditModal from './AdEditModal';
import Button from 'components/Button';
import ConfirmModal from 'components/Modal/ConfirmModal';
import LoadingCircle from 'components/LoadingCircle';
import PageContent from 'components/PageContent';

class AdsPage extends React.Component {
    constructor() {
        super();

        this.state = {
            showConfirmModal: false,
            showEditModal: false,
            useViewUrl: false
        };

        this.columns = [
            {
                text: 'Thumbnail',
                name: 'thumbnailUrl'
            }, {
                text: 'Name',
                name: 'name'
            }, {
                text: 'Title',
                name: 'titleCopy'
            }, {
                text: 'Body',
                name: 'bodyCopy'
            }, {
                text: 'Ad URL',
                name: 'viewUrl'
            },{
                text: 'Status',
                name: 'status'
            }, {
                text: 'Placement',
                name: 'placement'
            }, {
                text: 'Link',
                name: 'linkUrl'
            }, {
                text: 'Actions',
                name: 'actions'
            }
        ];
    }

    componentDidMount() {
        document.body.classList.add('ads-page');

        this.props.getAds();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.ads.ad && this.props.ads.ad && prevProps.ads.ad.id !== this.props.ads.ad.id) {
            this.setState({useViewUrl: this.props.ads.ad.viewUrl != null })
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('ads-page');
    }

    handleSave = () => {
        return this.props.putAd(this.state.useViewUrl)
            .then((res) => {
                if(res.code === 200) {
                    this.setState({showConfirmModal: true, showEditModal: false});
                }
            })
    };

    openEditModal = (ad) => {
        console.log(ad);
        this.props.setAd(ad);
        this.setState({showEditModal: true});
    };

    render() {
        return (
            <PageContent>
                <div className="ads">
                    <Button onClick={() => this.setState({showEditModal: true})}
                            type="button">
                        New Campaign
                    </Button>

                    {this.props.ads.isFetching === true ? (
                        <LoadingCircle />
                    ) : (
                        <div className="prices__list--wrapper">
                            <table className="prices-table">
                                <thead>
                                <tr>
                                    {this.columns.map((col, index) => {
                                        return (
                                            <th className="users-table__heading"
                                                key={index}>
                                                {col.text}
                                            </th>
                                        )
                                    })}
                                </tr>
                                </thead>
                                <tbody>
                                    {this.props.ads.all.map((ad) => {
                                        return (
                                            <tr key={ad.id}>
                                                {this.columns.map((col, index) => {
                                                    if(col.name === 'thumbnailUrl') {
                                                        return (
                                                            <td key={index}>
                                                                <div className={`col-${col.name}`}>
                                                                    <img src={ad.thumbnailUrl} alt="" />
                                                                </div>
                                                            </td>
                                                        );
                                                    } else if(/name|titleCopy|bodyCopy|status|placement/.test(col.name)) {
                                                        return (
                                                            <td key={index}>
                                                                <div className={`col-${col.name}`}>
                                                                    {ad[col.name]}
                                                                </div>
                                                            </td>
                                                        );
                                                    } else if(col.name === 'linkUrl') {
                                                        return (
                                                            <td key={index}>
                                                                <div className={`col-${col.name}`}>
                                                                    {ad.linkUrl ? (
                                                                        <A href={ad.linkUrl} target="_blank">
                                                                            Link
                                                                        </A>
                                                                    ) : null}
                                                                </div>
                                                            </td>
                                                        );
                                                    } else if(col.name === 'actions') {
                                                        return (
                                                            <td key={index}>
                                                                <Button noStyles
                                                                        onClick={() => this.openEditModal(ad)}
                                                                        type="button">
                                                                    <img src="/img/icon--pencil.svg" alt="Edit" />
                                                                </Button>
                                                            </td>
                                                        )
                                                    } else if(col.name === 'viewUrl') {
                                                        return (
                                                            <td key={index}>
                                                                <div className={`col-${col.name}`}>
                                                                    {ad.viewUrl ? (
                                                                        <A href={ad.viewUrl} target="_blank">
                                                                            Ad
                                                                        </A>
                                                                    ) : null}
                                                                </div>
                                                            </td>
                                                        );
                                                    } else {
                                                        return (<td key={index}></td>)
                                                    }
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <ConfirmModal
                        confirmOnClick={() => this.setState({showConfirmModal: false})}
                        confirmText="OK"
                        contentLabel="Modal confirming your changes were saved"
                        show={this.state.showConfirmModal}
                        showDeclineButton={false}
                        title="Your campaign was successfully saved"
                    />

                    <AdEditModal
                        ad={this.props.ads.ad}
                        closeEditModal={() => this.setState({showEditModal: false})}
                        handleSubmit={this.handleSave}
                        isSaving={this.props.ads.isSaving}
                        setAd={this.props.setAd}
                        setUseViewUrl={(value) => this.setState({useViewUrl: value})}
                        show={this.state.showEditModal}
                        useViewUrl={this.state.useViewUrl}
                    />
                </div>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ads: state.ads
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getAds: () => dispatch(getAds()),
        putAd: (useViewUrl) => dispatch(putAd(useViewUrl)),
        setAd: (adObj) => dispatch(setAd(adObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdsPage);



// WEBPACK FOOTER //
// ./src/containers/AdsPage/index.js